import React from 'react';
import { NewTabLink } from 'shared/components/abstract/interactables';
import StickyHeadTable from 'shared/components/table/StickyHeadTable';

/**
 * @param {Object} props
 * @param {Object} props.groupDpsk - Group DPSK object
 * @param {boolean} props.groupDpskIsMissing - Whether group DPSK is missing
 * @param {Object} props.smartzone - Smartzone object
 */
export default function TenantWifiInfo(props) {
  const {
    groupDpsk,
    groupDpskIsMissing,
    smartzone,
  } = props;

  let wirelessType = '';
  let url = '';
  let ssid = '';

  if (smartzone.id) {
    wirelessType = `SmartZone (${smartzone.dpsk_type})`;
    url = smartzone.web_url;
    ssid = smartzone.wlan_ssid;
  }

  const columns = [
    {
      name: 'Wireless Type',
      formatter: () => wirelessType,
    },
    {
      name: 'URL',
      formatter: () => <NewTabLink link={url} />,
    },
    {
      name: 'SSID',
      formatter: () => ssid,
    },
  ];

  if (smartzone.id) {
    if (groupDpsk.id) {
      columns.push({
        name: 'Group Key',
        formatter: () => <code>{` ${groupDpsk.dpsk}`}</code>,
      });
    } else if (groupDpskIsMissing) {
      columns.push({
        name: 'Group Key',
        formatter: () => <i>{' Unit group key is missing!'}</i>,
      });
    }
  }

  // This has one row with values created by above closures.
  // A mock value is used for the rows prop so that react keys are created correctly.
  return (
    <StickyHeadTable
      columns={columns}
      noRowsText=""
      rowId="key"
      rows={[{ key: 'wifi-info-row' }]}
    />
  );
}
